export default "__VITE_ASSET__d358ed1b__"